var mzg;
if (!mzg) {
    mzg = {};
}

$.extend(mzg,
    /**
     * @lends mzg
     */
    {
        /**
         * @namespace
         * @description newsSlider
         */
        navigation: {
            _obj: $("#menu"),
            /**
             * @type {function}
             * @description initialize Navigation
             */
            init: function () {
                console.log('menuAim init');
                
                $('#menu .nav-item-level-1').hover(
                    function() {
                        if($(this).parent('.nav-level-1').hasClass('hiddenSubLevel2')){
                            $( this ).next('ul').find('li:first-child').find('ul').css('display', 'flex');    
                        } else {
                            $( this ).next('ul').find('li:first-child').addClass('show').find('ul').css('display', 'block');
                        }
                    }, 
                    function() {
                        //$('.nav-level-2 li').removeClass('show');
                    }
                );
                
                $('#menu .nav-level-1').hover(
                    function() {
                        $('.overlay-darken-page').show();
                        $( this ).find('.nav-level-2').addClass('active').show();
                    }, 
                    function() {
                        $('.overlay-darken-page').hide();
                        $('.nav-level-2 li').removeClass('show').find('ul').hide();
                        $( this ).find('.nav-level-2').removeClass('active').hide();
                    }
                );

                $('.dm-item_submenu-mega').each(function(){
                    if($(this).find('ul ul.nav__flyoutTeaser').length == 0){
                       $(this).find('> ul').addClass("flex-fix");
                    }
                });


                var subnavIsLocked = true;
                $(".subnav--mobile").click(function() {
                    subnavIsLocked = false;
                });

                $(".subnav--mobile").change(function() {
                    if(!subnavIsLocked) {
                        window.location.href = $(this).val();
                        subnavIsLocked = true;
                        $(this).data("isopen", !open);
                    }
                });

                //menuAim
                $('.nav-level-2').menuAim({
                    activate: mzg.navigation.activateSubmenu,
                    deactivate: mzg.navigation.deactivateSubmenu,
                    exitMenu: mzg.navigation.exitSubmenu,
                    rowSelector: "> li",
                    submenuDirection: "right",
                    activationDelay: 150
                });
                $('.hiddenSubLevel2 .nav-level-2').hover(
                    function(){
                        $(this).css('display','flex').find('ul').css('display','flex');
                    },
                    function(){                        
                    }
                );
                jQuery(".list-sidenav:eq(1)").css("display", "none");
            },
            activateSubmenu: function(row){
                $(row).addClass("show").find('> ul').css('display','flex');
            },
            deactivateSubmenu: function(){
                $('.nav-level-2 li').removeClass("show").find('> ul').hide();
            },
            exitSubmenu: function(){
                
            }
        }
    }
);

$(mzg.navigation.init);
